import React, { useEffect } from "react";
import { Typography } from "@mui/material";
import { useSelector } from "react-redux";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/system";
import ssImge from "../../../images/selectedImg2.jpg";
import regImg from "../../../images/rejectedImg1.jpg";
import { myCandidatesSelector } from "../../redux/selector";

const StepReject = () => {
  const { candidateDetails, jobDetails, selectedSubmission } =
    useSelector(myCandidatesSelector);

  const StyledPaper = styled(Paper)(({ theme }) => ({
    position: "relative",
    color: "#000",
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    backgroundImage: `url(${selectedSubmission?.pStatusName === "Selected" || selectedSubmission?.bench_status_id === 9 ? ssImge : regImg
      })`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    padding: theme.spacing(2),
    height: 400,
    marginTop: "20px",
    textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
  }));


  return (
    <StyledPaper elevation={3}>
      {selectedSubmission?.pStatusName === "Selected" || selectedSubmission?.bench_status_id === 9 ? (
        <Typography variant="body1" sx={{ fontSize: "20px" }}>
          Congratulations! The candidate,&nbsp;
          <span
            style={{
              color: "green",
              fontWeight: 600,
              textDecoration: "underline",
            }}
          >
            {candidateDetails.candidate_name}
          </span>
          , for the&nbsp;
          <span
            style={{
              color: "green",
              fontWeight: 600,
              textDecoration: "underline",
            }}
          >
            {selectedSubmission.jobtitle}
          </span>
          &nbsp;position has been selected. We appreciate your efforts in
          presenting the candidate, and we look forward to their successful
          journey with the client. Thank you for your continued partnership.
        </Typography>
      ) : (
        <Typography variant="body1" sx={{ fontSize: "20px" }}>
          We regret to inform you that the candidate,&nbsp;
          <span
            style={{
              color: "red",
              fontWeight: 600,
              textDecoration: "underline",
            }}
          >
            {candidateDetails.candidate_name}
          </span>
          , for the&nbsp;
          <span
            style={{
              color: "red",
              fontWeight: 600,
              textDecoration: "underline",
            }}
          >
            {selectedSubmission.jobtitle}
          </span>
          &nbsp;
          {selectedSubmission?.pStatusName === "Rejected" ? (
            <>
              position has not been selected for further consideration by the client. We appreciate your efforts in presenting the candidate, and we encourage you to explore additional opportunities available on our platform. Our team is here to support you in finding the right match for your client's needs. Thank you for your continued partnership.
            </>
          ) : selectedSubmission?.pStatusName === "Job Rejected By Candidate" ? (
            <>
              position was declined by the candidate.  Thank you for your continued partnership.
            </>
          ) : null}
          {/* {selectedSubmission?.pStatusName === "Rejected" ? " (Candidate Rejected)" : "Job Rejected By Candidate" ? :""}
          &nbsp;position has not been selected for further consideration by the
          client. We appreciate your efforts in presenting the candidate, and we
          encourage you to explore additional opportunities available on our
          platform. Our team is here to support you in finding the right match
          for your client's needs. Thank you for your continued partnership. */}
        </Typography>
      )}
    </StyledPaper>
  );
};

export default StepReject;
